import React from 'react';

import { Text } from 'app/shopify/theme';
import { Column, Row } from 'app/shopify/components/layout';

import { IconButton } from './IconButton';

export function IconButtonShowcase() {
  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <Text variant="bodySmall" color="text.secondary">
        Icon Button - exemple avec l&apos;icône arrow-right du SVG fourni.
      </Text>

      <Row gap="spacing.general.x3">
        <IconButton variant="primary" size="large" />
        <IconButton variant="secondary" size="large" />
        <IconButton variant="secondaryNeutral" size="large" />
        <IconButton variant="tertiary" size="large" />
        <IconButton variant="ghost" size="large" />
        <IconButton variant="ghostNeutral" size="large" />
      </Row>

      <Row gap="spacing.general.x3">
        <IconButton variant="primary" size="medium" />
        <IconButton variant="primary" size="small" />
        <IconButton variant="primary" size="large" state="hover" />
        <IconButton variant="primary" size="large" state="pressed" />
        <IconButton variant="primary" size="large" state="focus" />
        <IconButton variant="primary" size="large" state="loading" />
      </Row>

      <Row gap="spacing.general.x3">
        <IconButton variant="primary" size="large" inverted />
        <IconButton variant="tertiary" size="large" inverted />
        <IconButton variant="ghost" size="large" inverted />
        <IconButton variant="primary" size="medium" disabled />
      </Row>
    </Column>
  );
}
